/*
 * Copyright (c) 2025 Bolmate B.V.
 */

import React, {useContext, useState} from 'react';
import EmailStep from '../../../../models/emailStepModel';
import {hasAdminLogin} from '../../../../util/adminUtil';
import {getAdminEmailInfo} from '../../../../util/requestSender';
import {ResponseData, showDialog} from '@dvrd/dvr-controls';
import {AppContext} from '../../../misc/appContext';
import EmailAdminInfo from './emailAdminInfo';

interface Props {
    emailStepID: string;
}

export default function EmailAdminInfoController(props: Props) {
    const {user} = useContext(AppContext).userContext;
    const [emailStep, setEmailStep] = useState<EmailStep | null>(null);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    if (!user?.isAdmin() && !hasAdminLogin()) return null;

    function onActivate() {
        setOpen(true);
        loadInfo();
    }

    function onClose() {
        setOpen(false);
    }

    function loadInfo() {
        setLoading(true);
        getAdminEmailInfo({
            id: props.emailStepID, callback: (data: ResponseData) => {
                setLoading(false);
                if (data.success) setEmailStep(new EmailStep(data.email_step));
                else showDialog(data.message ?? 'Het laden is mislukt');
            }
        });
    }

    return (
        <EmailAdminInfo emailStep={emailStep} open={open} loading={loading} onClose={onClose} onActivate={onActivate}/>
    );
}

EmailAdminInfoController.displayName = 'EmailAdminInfoController';